import { jsx as _jsx } from "react/jsx-runtime";
import { AppBarAppMobileTeleporter } from "@sprout/client-components/dist/AppBar";
import { Flex } from "sprout-ui-primitives";
const TopicPageAppBarMobile = (props)=>{
    const { children  } = props;
    return /*#__PURE__*/ _jsx(AppBarAppMobileTeleporter, {
        children: /*#__PURE__*/ _jsx(Flex, {
            ml: "auto",
            alignItems: "center",
            children: children
        })
    });
};
export default TopicPageAppBarMobile;
